import { render } from "./DzAndroid.vue?vue&type=template&id=aa6b85c4&scoped=true"
import script from "./DzAndroid.vue?vue&type=script&lang=js"
export * from "./DzAndroid.vue?vue&type=script&lang=js"

import "./DzAndroid.vue?vue&type=style&index=0&id=aa6b85c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa6b85c4"]])

export default __exports__